<template>
  <div>
    <img
        :src="icons.warning"
        class="icon">

    <h1 class="account-verification__step__title">
      Are you sure to override verification?
    </h1>

    <p class="account-verification__step__description">
      Use of this function is recorded by Ring's Internal Security Team.
    </p>

    <div class="warning-container">
      <table class="table">
        <tr>
          <td>
            <img
                :src="icons.info"
                class="warning-container__icon__img">
          </td>
          <td class="table__title">
            Warning
          </td>
        </tr>
        <tr>
          <td></td>
          <td class="table__description">
            This is a restricted function and should only be used when there is a business need.
          </td>
        </tr>
      </table>
    </div>

    <div class="override-buttons-container">
      <el-button
          plain
          type="primary"
          class="account-verification__step__button account-verification__step__button-white"
          @click="cancelOverride">
        {{ cancelButtonText }}
      </el-button>
      <el-button
          type="primary"
          class="account-verification__step__button"
          @click="processOverride">
        {{ processButtonText }}
      </el-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { createNamespacedHelpers as module } from "vuex";

const { mapGetters: accountGetters } = module("db/account");

export default {
  name: "VerifyOverride",
  emits: ["cancelOverrideRequested", "connectionError"],
  data() {
    return {
      icons: {
        warning: require("@/assets/icons/new-ui/customer/authorizations/shared/warning_blue.svg"),
        info: require("@/assets/icons/new-ui/customer/authorizations/shared/warning.svg"),
      },
      cancelButtonText: "Cancel",
      processButtonText: "Verify Override",
    };
  },
  computed: {
    ...accountGetters(["customerId"]),
  },
  methods: {
    cancelOverride() {
      this.$emit("cancelOverrideRequested", true);
    },
    processOverride() {
      return axios
        .post(`v3/customers/${this.customerId}/account_verification/override`)
        .then((response) => {
          this.$router.go(this.$router.currentRoute);
        })
        .catch((error) => {
          this.$emit("connectionError", true);
        });
    },
  },
};
</script>

<style scoped>
icon {
  width: 40px;
  height: 36px;
}

.warning-container {
  background-color: #fcefef;
}

.warning-container__icon__img {
  width: 20px;
  height: 18px;
  margin-left: 26px;
  margin-right: 14px;
}

.table {
  padding-top: 19px;
  padding-bottom: 16px;
}

.table__title {
  width: 486px;
  height: 24px;

  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #424242;
}

.table__description {
  width: 486px;
  height: 48px;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
  color: #424242;
  padding-right: 60px;
}

.override-buttons-container {
  margin-top: 32px;
}
</style>
